import { getWindow } from './get-window';
export function requestAnimationFrameAsync(callback) {
  return new Promise(function (resolve, reject) {
    var win = getWindow();

    if (!win) {
      try {
        var result = callback();
        resolve(result);
      } catch (error) {
        reject(error);
      }

      return;
    }

    win.requestAnimationFrame(function (time) {
      try {
        var _result = callback(time);

        resolve(_result);
      } catch (error) {
        reject(error);
      }
    });
  });
}